var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41659 11.0837H7.58325V8.64824L8.51659 9.58157L9.33325 8.75033L6.99992 6.41699L4.66659 8.75033L5.49784 9.56699L6.41659 8.64824V11.0837ZM3.49992 12.8337C3.17909 12.8337 2.90453 12.7195 2.67625 12.4912C2.44797 12.263 2.33364 11.9882 2.33325 11.667V2.33366C2.33325 2.01283 2.44759 1.73827 2.67625 1.50999C2.90492 1.28171 3.17947 1.16738 3.49992 1.16699H8.16659L11.6666 4.66699V11.667C11.6666 11.9878 11.5524 12.2626 11.3242 12.4912C11.0959 12.7199 10.8211 12.834 10.4999 12.8337H3.49992ZM7.58325 5.25033V2.33366H3.49992V11.667H10.4999V5.25033H7.58325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.937420e2ebcbe4872cd03da3b9a62638.svg";
export { ForwardRef as ReactComponent };